import { PUT_CARD_APPLY_START } from '../../types';

export const put_card_apply = (payload) => ({
  type: PUT_CARD_APPLY_START,
  payload,
});
